// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5a957a44","453":"302c5caa","455":"f6d310a8"}[chunkId] + ".chunk.js";
};